import axios from "axios";
import environment from "../config/environment";

const apiClient = axios.create({
	baseURL: environment.apiUrl,
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
	},
	timeout: 60000,
});

apiClient.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("jwt_token");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		// Általános titkos kulcs header minden kéréshez
		if (environment.secretSoftwareKey) {
			config.headers["X-Secret-Software-Key"] = environment.secretSoftwareKey;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

apiClient.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response) {
			console.error("API hiba:", error.response.status, error.response.data);

			if (error.response.status === 401 || error.response.status === 403) {
				localStorage.removeItem("jwt_token");
				window.location.href = "/";
			}
		} else if (error.request) {
			console.error("Nincs válasz a szervertől:", error.request);
		} else {
			console.error("Kérés hiba:", error.message);
		}

		return Promise.reject(error);
	}
);

export default apiClient;
